const FormatNumberPlugin = {
    install(Vue) {
        Vue.prototype.$formatNumber = (number) => {
            return Intl.NumberFormat("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(number);
        };
    },
};

export default FormatNumberPlugin;
